import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/services/toxicology/extractables-leachables-reports")({
  beforeLoad: () => { throw redirect({ href: "/zh-cn/services/regulatory-toxicology/extractables-leachables-reports", statusCode: 301 }); },
});
